<template>
	<aside class="loader" :style="{ width: props.size, height: props.size }">
		<svg viewBox="0 0 100 100" :width="props.size" :height="props.size" aria-hidden="true">
			<path
				d="M 50 10 A 40 40 0 0 1 90 50"
				fill="none"
				stroke="currentColor"
				stroke-width="5"
				stroke-linecap="round"
			/>
		</svg>
	</aside>
</template>
<script lang="ts" setup>
import "./Loader.scss";

interface Props
{
	size? : number
}

let props = withDefaults(defineProps<Props>(), {
	size : 48
});
</script>